import { mergeProps, useFocusRing } from 'react-aria';

import { Glyph } from '../../common/Glyph';
import { TextRegular } from '../../common/text/TextRegular';
import { useOptionContext } from '../../list-box/ListBox';
import { ListItem } from '../../list-box/ListItem';

import { useDevice } from '../../../store/devices/useDevices.ts';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';
import styles from './OptionDeviceDeviceControls.module.css';

export function OptionDeviceDeviceControls(props) {
  const { ref, option, state, item, value } = useOptionContext();

  const focusRing = useFocusRing();

  const { device } = useDevice({ deviceId: item.key });

  return (
    <ListItem.Root
      {...mergeProps(option.optionProps, focusRing.focusProps)}
      ref={ref}
      className={props.className}
      style={{ '--indent-level': value.level }}
      as={props.as}
      data-is-selected={option.isSelected}
      data-is-focused={option.isFocused}
      data-is-pressed={option.isPressed}
      data-is-disabled={option.isDisabled}
      data-is-focus-visible={focusRing.isFocusVisible}
    >
      <div
        className={styles.root}
        style={{
          borderBottom: `1px solid ${
            state.collection.size === item.index + 1
              ? 'transparent'
              : item.index === 0
                ? theme.color.line
                : theme.color.line_light
          }`,
        }}
      >
        {device?.available === false && (
          <Glyph
            className={styles.icon}
            source={glyph.core.exclamationmarkTriangleFill}
            size={theme.icon.size_medium}
            color={device.group != null ? theme.color.yellow : theme.color.red}
          />
        )}

        <div className={styles.textWrapper} data-is-text-medium={item.key === state.selectedKey}>
          <TextRegular className={styles.text} textAlign="center">
            {device?.name}
          </TextRegular>
        </div>
      </div>
    </ListItem.Root>
  );
}
